import * as style from "./style";

export const Subtitle: React.FC = ({ children }) => {
  return <style.Subtitle>{children}</style.Subtitle>;
};
